__turbopack_context__.v({
  "helios-section": "YgUhHa_helios-section",
  "helios-section--band-brand": "YgUhHa_helios-section--band-brand",
  "helios-section--band-dark": "YgUhHa_helios-section--band-dark",
  "helios-section--band-flush": "YgUhHa_helios-section--band-flush",
  "helios-section--band-subtle": "YgUhHa_helios-section--band-subtle",
  "helios-section--surface-brand": "YgUhHa_helios-section--surface-brand",
  "helios-section--surface-dark": "YgUhHa_helios-section--surface-dark",
  "helios-section--surface-page": "YgUhHa_helios-section--surface-page",
  "helios-section--surface-subtle": "YgUhHa_helios-section--surface-subtle",
  "helios-section--surface-transparent": "YgUhHa_helios-section--surface-transparent",
});
